import { z } from 'zod'

/**
 * The visual vocabulary for the counting modes.
 *
 * Every shape has to be distinguishable at a glance, at small sizes, and while
 * moving — so they differ in silhouette (vertex count, fill, symmetry) rather
 * than only in colour. Players who cannot distinguish colour must still be able
 * to play, which is why the brief names the shape and never the colour.
 */
export const SHAPES = [
  'circle',
  'triangle',
  'square',
  'diamond',
  'hexagon',
  'star',
  'cross',
  'ring',
] as const

export const shapeSchema = z.enum(SHAPES)
export type Shape = z.infer<typeof shapeSchema>

/** Human-readable singular/plural used in the pre-round brief. */
export const SHAPE_LABELS: Record<Shape, { one: string; many: string }> = {
  circle: { one: 'Circle', many: 'Circles' },
  triangle: { one: 'Triangle', many: 'Triangles' },
  square: { one: 'Square', many: 'Squares' },
  diamond: { one: 'Diamond', many: 'Diamonds' },
  hexagon: { one: 'Hexagon', many: 'Hexagons' },
  star: { one: 'Star', many: 'Stars' },
  cross: { one: 'Cross', many: 'Crosses' },
  ring: { one: 'Ring', many: 'Rings' },
}
